var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"base-button",class:{ 'full-width': _vm.fullWidth, shrink: _vm.shrink },style:({
    height: _vm.dense ? _vm.smallButtonHeight : _vm.largeButtonHeight,
    color: _vm.textColor
  }),attrs:{"color":_vm.color,"disabled":_vm.disabled,"elevation":"0","text":_vm.text,"loading":_vm.loading},on:{"click":_vm.handleClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }